<template>
  <div class="container mx-auto h-full py-5">
    <el-dialog
      :visible.sync="showAssignAP"
      width="1000px"
      :close-on-click-modal="false"
      title="Asignar acción de personal"
    >
      <el-form
        :model="assignAP"
        status-icon
        :rules="assignAPRules"
        ref="newAP"
        label-position="top"
        @submit.native.prevent="
          submitNewAP('newAP', assignAP, selectedAP, employees)
        "
      >
        <el-row :gutter="15" class="border-t pt-4 text-xs">
          <el-col :span="8">
            <el-form-item
              label="Seleccione accion de personal"
              prop="personalAction"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="assignAP.personalAction"
                placeholder="Select"
                size="small"
                class="w-full"
                clearable
                @change="getSelectedAP(assignAP.personalAction)"
                filterable
              >
                <el-option
                  v-for="c in personalActions"
                  :key="c.id"
                  :label="`${c.type.name}: ${c.name}`"
                  :value="c.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="selectedAP">
            <el-col :span="4" v-if="!selectedAP.isFixedValue">
              <el-form-item
                :label="`Cantidad: ${
                  selectedAP
                    ? selectedAP.affectsMethod == 1
                      ? '(DIAS)'
                      : '(DINERO)'
                    : ''
                }`"
                prop="noFixedValue"
                :rules="{
                  required: true,
                  message: 'Este campo es requerido.',
                  trigger: 'change',
                }"
              >
                <el-input-number
                  :min="0.01"
                  :step="0.01"
                  placeholder="Cantidad"
                  v-model="assignAP.noFixedValue"
                  size="small"
                  style="width: 100%"
                  @change="updateManageAP('amount')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="flex flex-col space-y-2"
              v-if="selectedAP"
            >
              <el-form-item label="Comentarios">
                <el-input
                  size="small"
                  v-model="selectedAP.comment"
                  placeholder=""
                  @change="updateManageAP('comment')"
                />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <el-row
          :gutter="15"
          class="border-t py-2 mb-4 text-xs"
          v-if="selectedAP"
        >
          <el-col :span="24">
            <el-row :gutter="15">
              <el-col :span="16">
                <span class="uppercase font-semibold">Asignar a:</span>
              </el-col>
              <el-col :span="8">
                <el-input
                  placeholder="Buscar"
                  v-model="searchValueDialog"
                  size="small"
                  suffix-icon="el-icon-search"
                  clearable
                />
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-table
                  ref="multipleTable"
                  :data="
                    employees.filter(
                      (data) =>
                        !searchValueDialog ||
                        data.code
                          .toLowerCase()
                          .includes(searchValueDialog.toLowerCase()) ||
                        data.fullName
                          .toLowerCase()
                          .includes(searchValueDialog.toLowerCase())
                    )
                  "
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  size="mini"
                  row-key="id"
                >
                  <el-table-column
                    type="selection"
                    reserve-selection
                    width="55"
                  >
                  </el-table-column>
                  <el-table-column
                    label="Codigo"
                    min-width="80"
                    prop="code"
                  ></el-table-column>
                  <el-table-column label="Empleado" min-width="270">
                    <template slot-scope="scope">
                      {{
                        `${scope.row.name1 ? `${scope.row.name1} ` : ""}${
                          scope.row.name2 ? `${scope.row.name2} ` : ""
                        }${
                          scope.row.lastname1 ? `${scope.row.lastname1} ` : ""
                        }${
                          scope.row.lastname2 ? `${scope.row.lastname2} ` : ""
                        }`
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="`Cantidad: ${
                      selectedAP
                        ? selectedAP.affectsMethod == 1
                          ? '(DIAS)'
                          : '(DINERO)'
                        : ''
                    }`"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        :min="0.01"
                        :step="0.01"
                        placeholder="Cantidad"
                        size="mini"
                        style="width: 100%"
                        :disabled="!scope.row.include"
                        v-model="scope.row.amount"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="Comentarios" width="400">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        placeholder=""
                        :disabled="!scope.row.include"
                        v-model="scope.row.comment"
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="showAssignAP = false"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24">
            <h3 class="text-l font-semibold">
              ASIGNACIÓN DE ACCIONES DE PERSONAL
            </h3>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="my-3">
          <el-col :span="24">
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${paysheet.code}) se ha abierto de manera extemporanéa.`"
              type="info"
              show-icon
              v-if="paysheet.override"
            />
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${
                paysheet.code
              }) estará disponible hasta el ${
                paysheet.sequence == 1 ? paysheet.limitQ1 : paysheet.limitQ2
              }/${
                new Date().getMonth() + 1
              }/${new Date().getFullYear()} 23:59:59`"
              type="info"
              show-icon
              v-else-if="!paysheetChangeDisabled"
            />
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${
                paysheet.code
              }) ha sido cerrado automaticamente por el sistema el ${
                paysheet.sequence == 1 ? paysheet.limitQ1 : paysheet.limitQ2
              }/${
                new Date().getMonth() + 1
              }/${new Date().getFullYear()} 23:59:59`"
              type="warning"
              show-icon
              v-else
            />
          </el-col>
        </el-row>

        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="success"
              size="small"
              icon="el-icon-plus"
              @click="openShowAssignAP"
              :disabled="paysheetChangeDisabled"
            >
              Agregar A.P.
            </el-button>
            <el-button
              type="default"
              size="small"
              icon="el-icon-printer"
              @click="printReport(table.data, 2)"
            >
              Gratificaciones
            </el-button>
            <el-button
              type="default"
              size="small"
              icon="el-icon-printer"
              @click="printReport(table.data, 3)"
            >
              Descuentos
            </el-button>
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>

        <div class="flex flex-col mt-4">
          <div
            class="
              flex flex-row
              border-b
              pb-1
              text-xs
              font-semibold
              text-gray-600
            "
          >
            <span
              v-for="(h, k) in table.headers"
              :key="k"
              class="flex flex-row px-1"
              :class="h.classes"
              :style="{ width: `${table.widths[k]}px` }"
            >
              {{ h.title }}
            </span>
          </div>
          <div
            class="h-16 flex flex-row justify-center items-center border-b"
            v-if="filteredEmployees.length == 0"
          >
            <span class="text-xs text-gray-400">Sin Datos</span>
          </div>
          <ul class="flex flex-col text-xs" v-else>
            <li
              v-for="(v, j) in filteredEmployees"
              class="flex flex-col hover:bg-gray-50 border-b"
              :class="{ 'bg-gray-100': j % 2 != 0 }"
              :key="j"
            >
              <div class="flex flex-row w-full">
                <div
                  @click="v.extended = !v.extended"
                  class="flex flex-row items-center h-8 px-1 cursor-pointer"
                  :class="table.headers[0].classes"
                  :style="{ width: `${table.widths[0]}px` }"
                >
                  <svg
                    v-if="v.extended"
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                  <svg
                    v-else
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
                <div
                  class="flex flex-row w-full cursor-pointer"
                  @click="v.extended = !v.extended"
                >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[1].classes"
                    :style="{ width: `${table.widths[1]}px` }"
                    >{{ j + 1 }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[2].classes"
                    :style="{ width: `${table.widths[2]}px` }"
                    >{{
                      `${v.code} - ${v.name1 ? `${v.name1} ` : ""}${
                        v.name2 ? `${v.name2} ` : ""
                      }${v.lastname1 ? `${v.lastname1} ` : ""}${
                        v.lastname2 ? `${v.lastname2} ` : ""
                      }`
                    }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[3].classes"
                    :style="{ width: `${table.widths[3]}px` }"
                  >
                    {{ v.paysheet.startDate | formatDate }} -
                    {{ v.paysheet.endDate | formatDate }}
                  </span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[4].classes"
                    :style="{ width: `${table.widths[4]}px` }"
                  >
                    {{ v.paysheet.code }}
                  </span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[5].classes"
                    :style="{ width: `${table.widths[5]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[6].classes"
                    :style="{ width: `${table.widths[6]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[7].classes"
                    :style="{ width: `${table.widths[7]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[8].classes"
                    :style="{ width: `${table.widths[8]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[9].classes"
                    :style="{ width: `${table.widths[9]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[10].classes"
                    :style="{ width: `${table.widths[10]}px` }"
                  ></span>
                </div>
              </div>
              <ul class="flex flex-col w-full" v-if="v.extended">
                <li
                  class="flex flex-row w-full"
                  v-for="(o, i) of v.personalActions"
                  :key="i"
                >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[0].classes"
                    :style="{ width: `${table.widths[0]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[1].classes"
                    :style="{ width: `${table.widths[1]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[2].classes"
                    :style="{ width: `${table.widths[2]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[3].classes"
                    :style="{ width: `${table.widths[3]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[4].classes"
                    :style="{ width: `${table.widths[4]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[5].classes"
                    :style="{ width: `${table.widths[5]}px` }"
                    >{{ o.personalAction.name }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[6].classes"
                    :style="{ width: `${table.widths[6]}px` }"
                    >{{ o.comment }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[7].classes"
                    :style="{ width: `${table.widths[7]}px` }"
                    >{{
                      o.personalAction.affectsMethod == 1 ? "Dias" : "Cantidad"
                    }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[8].classes"
                    :style="{ width: `${table.widths[8]}px` }"
                    >{{ o.value | formatMoney }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[9].classes"
                    :style="{ width: `${table.widths[9]}px` }"
                    >{{ o.amount }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[10].classes"
                    :style="{ width: `${table.widths[10]}px` }"
                  >
                    <button
                      class="hover:bg-red-500 p-1 rounded-full hover:text-white"
                      @click="deleteEmployeePersonalAction(o)"
                      v-if="!paysheetChangeDisabled"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg></button
                  ></span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="[].length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import { getHeader, getFooter, formatMoney } from "../../../utils";
import dfn from "date-fns";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "EmployeesOvertime",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          paysheets { id paysheetType { id name days } month year sequence active code startDate endDate limitQ1 limitQ2 override }
          employees (where: { show: true }) {
            oldDepartment { name }
            id
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            paysheetType { id }
            code
            currentSalary
            terminated
            department {
              name
              parentDepartment { id name }
            }
            userActions { id }
            personalActions {
              id
              personalAction { name type affectsMethod isFixedValue isRecurrent assignedBySupervisor }
              startDate
              endDate
              value
              amount
              affectsPaysheet
              isRecurrent
              quincenaUno
              quincenaDos
              comment
            }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({ employees: data.employees, paysheets: data.paysheets })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      table: {
        widths: [
          "40",
          "30",
          "320",
          "184",
          "120",
          "200",
          "260",
          "100",
          "100",
          "100",
          "40",
        ],
        headers: [
          {
            title: "",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
          {
            title: "Nombre completo",
            classes: [],
          },
          {
            title: "Periodo",
            classes: [],
          },
          {
            title: "Nómina",
            classes: [],
          },
          {
            title: "Accion de personal",
            classes: [],
          },
          {
            title: "Comentario",
            classes: [],
          },
          {
            title: "Forma",
            classes: [],
          },
          {
            title: "Valor",
            classes: [],
          },
          {
            title: "Cantidad",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
        ],
        data: [],
      },
      searchValue: "",
      searchValueDialog: "",
      page: {
        size: 15,
        number: 1,
      },
      employees: [],
      paysheets: [],
      personalActions: [],
      personalActionsTypes: [
        {
          name: "Administrativas",
          id: "1",
        },
        {
          name: "Gratificaciones",
          id: "2",
        },
        {
          name: "Descuentos",
          id: "3",
        },
      ],
      showAssignAP: false,
      assignAP: {
        personalAction: "",
        noFixedValue: null,
        startDate: "",
        endDate: "",
        quincenaUno: false,
        quincenaDos: false,
      },
      assignAPRules: {},
      selectedAP: null,
      activePaysheet: {},
      multipleSelection: [],
      paysheet: {},
    };
  },
  methods: {
    setData({ employees, paysheets }) {
      const paysheetTypes = paysheets.filter((p) => p.active);
      this.employees = employees
        .filter((e) => {
          const paysheetTypesList = paysheetTypes.map((p) => p.paysheetType.id);
          return (
            e.userActions != null &&
            !e.terminated &&
            e.userActions.id == this.$store.getters.userID &&
            paysheetTypesList.includes(e.paysheetType.id) &&
            e.department.parentDepartment != null
          );
        })
        .map((e) => ({
          ...e,
          include: false,
          amount: 0.01,
          comment: "",
          fullName: `${e.name1 ? `${e.name1} ` : ""}${
            e.name2 ? `${e.name2} ` : ""
          }${e.name3 ? `${e.name3} ` : ""}${
            e.lastname1 ? `${e.lastname1} ` : ""
          }${e.lastname2 ? `${e.lastname2} ` : ""}${
            e.lastname3 ? `${e.lastname3} ` : ""
          }`,
        }));
      this.paysheets = paysheets;

      this.paysheet = paysheets.find((p) => p.active);
      const activePaysheet = paysheetTypes.find((p) => p.active);
      this.activePaysheet = activePaysheet;
      this.assignAP.quincenaUno = activePaysheet.sequence == 1;
      this.assignAP.quincenaDos = activePaysheet.sequence == 2;

      this.assignAP.startDate = activePaysheet.startDate;
      this.assignAP.endDate = activePaysheet.endDate;

      const [psyear, psmonth, psday] = activePaysheet.startDate.split("-");
      const [peyear, pemonth, peday] = activePaysheet.endDate.split("-");
      this.table.data = this.employees.map((e) => {
        return {
          ...e,
          extended: true,
          paysheet: activePaysheet,
          personalActions: e.personalActions
            .filter(
              (pa) =>
                pa.startDate &&
                pa.endDate &&
                pa.personalAction.assignedBySupervisor
            )
            .filter((pa) => {
              const [pasyear, pasmonth, pasday] = pa.startDate.split("-");
              const [paeyear, paemonth, paeday] = pa.endDate.split("-");
              return (
                new Date(`${pasmonth}/${pasday}/${pasyear}`) >=
                  new Date(`${psmonth}/${psday}/${psyear}`) &&
                new Date(`${paemonth}/${paeday}/${paeyear}`) <=
                  new Date(`${pemonth}/${peday}/${peyear}`)
              );
            }),
        };
      });
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    async openShowAssignAP() {
      if (this.paysheetChangeDisabled) return;
      axios
        .post("/", {
          query: `
          {
            personalActions {
              id
              type
              name
              affectsPaysheet
              affectsMethod
              isFixedValue
              fixedValue
              isRecurrent
              updateStatus
              active
              deductISR
              baseSalary
              assignable
              assignedBySupervisor
            }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.personalActions = data.personalActions
              .filter(
                (pa) => pa.assignedBySupervisor && pa.assignable && pa.active
              )
              .map((d) => {
                return {
                  ...d,
                  type: this.personalActionsTypes.find((p) => p.id == d.type),
                };
              });
            this.showAssignAP = true;
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.clearSelection();
            }
            this.selectedAP = null;
            if (this.$refs.newAP) {
              this.$refs.newAP.resetFields();
            }
          }
        });
    },
    getSelectedAP(id) {
      this.selectedAP = this.personalActions.find((pa) => pa.id == id);
    },
    handleSelectionChange(val) {
      // Obtiene los ids que ya estan seleccionados
      const actual = this.employees.filter((e) => e.include);
      // Obtiene los ids de la nueva seleccion
      const selections = val.map((v) => v.id);
      // Deshabilita
      for (const e of actual.filter((a) => !selections.includes(a.id))) {
        e.include = false;
        e.amount = "";
        e.comment = "";
      }
      // Habilita
      for (const e of this.employees.filter((e) => selections.includes(e.id))) {
        e.include = true;
        if (!e.amount || e.amount == 0.01) {
          e.amount = this.assignAP.noFixedValue;
        }
        if (!e.comment || e.comment == "") {
          e.comment = this.selectedAP.comment;
        }
      }
    },
    updateManageAP(field) {
      for (const e of this.employees) {
        if (e.include) {
          switch (field) {
            case "comment":
              e.comment = this.selectedAP.comment;
              break;
            case "amount":
              e.amount = this.assignAP.noFixedValue;
              break;
          }
        }
      }
    },
    submitNewAP(formName, assignAP, selectedAP, employees) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return false;
        if (employees.filter((e) => e.include).length == 0) {
          return this.$notify({
            title: "Error",
            message: `Debes asignar la acción de personal a un empleado al menos`,
            type: "error",
            duration: 3500,
          });
        }
        this.$confirm(
          `¿Estás seguro que deseas agregar esta accion de personal para los empleados seleccionados?`,
          "Confirmación",
          {
            confirmButtonText: `Si, agregar`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";

                const quincenaUno = assignAP.quincenaUno;
                const quincenaDos = assignAP.quincenaDos;
                const startDate = assignAP.startDate;
                const endDate = assignAP.endDate;

                let data = "";
                for (const employee of employees.filter((e) => e.include)) {
                  // Debe enviarse en canitdad ($)
                  let value = null;
                  switch (selectedAP.affectsMethod) {
                    case 1: //Dias
                      // convierte dias a cantidad
                      value =
                        (employee.laboral.currentSalary / 30) * employee.amount;
                      break;

                    case 2: // Cantidad
                      value = selectedAP.isFixedValue
                        ? selectedAP.fixedValue
                        : employee.amount;
                      break;
                  }
                  // Multiplica por 1 en caso de gratificaciones y por -1 en caso de descuentos
                  switch (selectedAP.type.id) {
                    case "1":
                      value = value * 1;
                      break;
                    case "2":
                      value = value * 1;
                      break;
                    case "3":
                      value = value * -1;
                      break;
                  }

                  data += `{
                        employee: "${employee.id}"
                        personalAction: "${selectedAP.id}"
                        value: ${value.roundDecimal()}
                        affectsPaysheet: ${selectedAP.affectsPaysheet}
                        isRecurrent: ${selectedAP.isRecurrent}
                        quincenaUno: ${quincenaUno}
                        quincenaDos: ${quincenaDos}
                        comment: ${
                          employee.comment ? `"${employee.comment}"` : null
                        }
                        startDate: "${startDate}"
                        endDate: "${endDate}"
                        amount: ${employee.amount}
                      },`;
                }
                axios
                  .post("/", {
                    query: `mutation { 
                      employeePersonalActionCreateMultiple(data: [${data}])
                      { 
                        id
                        employee { id }
                        personalAction { name type affectsMethod isFixedValue isRecurrent assignedBySupervisor }
                        startDate
                        endDate
                        value
                        amount
                        affectsPaysheet
                        isRecurrent
                        quincenaUno
                        quincenaDos
                        comment
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se han asignado la acciones de personal correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });

                    if (this.$refs.multipleTable) {
                      this.$refs.multipleTable.clearSelection();
                    }
                    this.selectedAP = null;
                    this.$refs.newAP.resetFields();
                    const [psyear, psmonth, psday] =
                      this.activePaysheet.startDate.split("-");
                    const [peyear, pemonth, peday] =
                      this.activePaysheet.endDate.split("-");
                    this.table.data = this.employees.map((e) => {
                      return {
                        ...e,
                        include: false,
                        amount: 0.01,
                        comment: "",
                        extended: true,
                        paysheet: this.activePaysheet,
                        personalActions:
                          data.employeePersonalActionCreateMultiple
                            .filter((pa) => pa.startDate && pa.endDate)
                            .filter((pa) => {
                              const [pasyear, pasmonth, pasday] =
                                pa.startDate.split("-");
                              const [paeyear, paemonth, paeday] =
                                pa.endDate.split("-");
                              return (
                                pa.employee.id == e.id &&
                                pa.personalAction.assignedBySupervisor &&
                                new Date(`${pasmonth}/${pasday}/${pasyear}`) >=
                                  new Date(`${psmonth}/${psday}/${psyear}`) &&
                                new Date(`${paemonth}/${paeday}/${paeyear}`) <=
                                  new Date(`${pemonth}/${peday}/${peyear}`)
                              );
                            }),
                      };
                    });
                    setTimeout(() => {
                      this.showAssignAP = false;
                    }, 500);

                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, agregar`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    deleteEmployeePersonalAction({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar esta accion de personal?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    employeePersonalActionDelete(where: {id: ${id} }) { 
                        id
                        employee { id }
                        personalAction { name type affectsMethod isFixedValue isRecurrent assignedBySupervisor }
                        startDate
                        endDate
                        value
                        amount
                        affectsPaysheet
                        isRecurrent
                        quincenaUno
                        quincenaDos
                        comment
                     } 
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado la accion de personal correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                  });

                  const [psyear, psmonth, psday] =
                    this.activePaysheet.startDate.split("-");
                  const [peyear, pemonth, peday] =
                    this.activePaysheet.endDate.split("-");
                  this.table.data = this.employees.map((e) => {
                    return {
                      ...e,
                      extended: true,
                      paysheet: this.activePaysheet,
                      personalActions: data.employeePersonalActionDelete
                        .filter((pa) => pa.startDate && pa.endDate)
                        .filter((pa) => {
                          const [pasyear, pasmonth, pasday] =
                            pa.startDate.split("-");
                          const [paeyear, paemonth, paeday] =
                            pa.endDate.split("-");
                          return (
                            pa.employee.id == e.id &&
                            pa.personalAction.assignedBySupervisor &&
                            new Date(`${pasmonth}/${pasday}/${pasyear}`) >=
                              new Date(`${psmonth}/${psday}/${psyear}`) &&
                            new Date(`${paemonth}/${paeday}/${paeyear}`) <=
                              new Date(`${pemonth}/${peday}/${peyear}`)
                          );
                        }),
                    };
                  });
                  done();
                })
                .catch(console.log)
                .then((alw) => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                });
            } else {
              done();
            }
          },
        }
      );
    },
    printReport(values, type) {
      const data = [];
      const filtered = values
        .filter((v) => v.personalActions.length > 0)
        .map((v) => {
          return {
            ...v,
            personalActions: v.personalActions.filter(
              (pa) => pa.personalAction.type == type
            ),
          };
        });
      for (const v of filtered) {
        data.push([
          { text: v.code, border: [false, true, false, false] },
          {
            text: `${v.name1 ? `${v.name1} ` : ""}${
              v.name2 ? `${v.name2} ` : ""
            }${v.name3 ? `${v.name3} ` : ""}${
              v.lastname1 ? `${v.lastname1} ` : ""
            }${v.lastname2 ? `${v.lastname2} ` : ""}${
              v.lastname3 ? `${v.lastname3} ` : ""
            }`,
            border: [false, true, false, false],
          },
          {
            text: v.oldDepartment ? v.oldDepartment.name : "",
            border: [false, true, false, false],
          },
          { text: "", border: [false, true, false, false] },
          { text: "", border: [false, true, false, false] },
        ]);

        for (const ap of v.personalActions) {
          data.push([
            "",
            { colSpan: 2, text: ap.comment, style: { italics: true } },
            "",
            { text: ap.personalAction.name, style: { italics: true } },
            {
              text: formatMoney(ap.value),
              alignment: "right",
              style: { italics: true },
            },
          ]);
        }
      }

      data.push(["", "", "", "", ""], ["", "", "", "", ""]);
      data.push([
        "",
        "",
        "",
        {
          text: "TOTAL",
          bold: true,
          alignment: "right",
          fontSize: 10,
          border: [false, true, false, false],
        },
        {
          border: [false, true, false, false],
          bold: true,
          alignment: "right",
          fontSize: 10,
          text: formatMoney(
            filtered.reduce(
              (a, b) => a + b.personalActions.reduce((c, d) => c + d.value, 0),
              0
            )
          ),
        },
      ]);

      const [syear, smonth, sday] = this.activePaysheet.startDate.split("-");
      const [eyear, emonth, eday] = this.activePaysheet.endDate.split("-");

      let periodoClosed = "PERIODO ";
      if (this.paysheet.override) {
        periodoClosed += `EXTEMPORANEO ${dfn.format(
          new Date(),
          "DD/MM/YYYY hh:mm:ss"
        )}`;
      } else if (!this.paysheetChangeDisabled) {
        periodoClosed += `ABIERTO ${dfn.format(
          new Date(),
          "DD/MM/YYYY hh:mm:ss"
        )}`;
      } else {
        periodoClosed += `CERRADO EL ${
          this.paysheet.sequence == 1
            ? this.paysheet.limitQ1
            : this.paysheet.limitQ2
        }/${new Date().getMonth() + 1}/${new Date().getFullYear()} 23:59:59`;
      }

      const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [20, 80, 20, 40],
        header: getHeader(
          "CALDER, SOCIEDAD ANÓNIMA",
          [
            new Date(`${smonth}/${sday}/${syear}`),
            new Date(`${emonth}/${eday}/${eyear}`),
          ],
          `REPORTE DE ${type == "G" ? "GRATIFICACIONES" : "DESCUENTOS"}`,
          "period",
          `USUARIO: ${this.$store.getters.shortName} | NOMINA: ${this.activePaysheet.code}`,
          periodoClosed
        ),
        footer: getFooter(),
        content: [
          {
            style: "tableStyle",
            layout: {
              defaultBorder: false,
            },
            table: {
              headerRows: 1,
              widths: [25, "*", 120, 100, 50],
              body: [
                [
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "COD.",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "NOMBRE/COMENTARIOS",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "DEPARTAMENTO",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "ACCION DE PERSONAL",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "VALOR",
                    bold: true,
                    alignment: "right",
                  },
                ],
                ...data,
              ],
            },
          },
        ],
        styles: {
          tableStyle: {
            fontSize: 8.5,
          },
        },
      };
      pdfMake.createPdf(docDefinition).open();
    },
  },
  computed: {
    filteredEmployees() {
      if (this.table.data.length == 0) {
        return [];
      } else {
        return this.table.data
          .sort((a, b) => {
            if (a.code > b.code) return 1;
            if (a.code < b.code) return -1;
            return 0;
          })
          .filter((e) => {
            const fullName = `${e.name1 ? e.name1.trim() : ""} ${
              e.name2 ? e.name2.trim() : ""
            } ${e.lastname1 ? e.lastname1.trim() : ""} ${
              e.lastname2 ? e.lastname2.trim() : ""
            }`;
            return (
              fullName.toLowerCase().includes(this.searchValue.toLowerCase()) ||
              e.code.toLowerCase().includes(this.searchValue.toLowerCase())
            );
          })
          .slice(
            this.page.number * this.page.size - this.page.size,
            this.page.size * this.page.number
          );
      }
    },
    paysheetChangeDisabled() {
      const { sequence, limitQ1, limitQ2, override } = this.paysheet;
      return override
        ? false
        : parseInt(dfn.format(new Date(), "DD")) >
            (sequence == 1 ? limitQ1 : limitQ2);
    },
  },
};
</script>
